import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// react-router's BrowserRouter doesn't reset scroll position on navigation,
// so navigating to a new route while scrolled down on the previous one
// (e.g. clicking "Cobertura" from partway down the home page) renders the
// new page still scrolled to that position — the fixed navbar overlaps the
// hero and it looks cut off. Skip when the URL carries a `#hash` (e.g.
// /#plan): App.js's own hash-scroll effect handles landing on that section.
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) return;
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
